import React from 'react';
import {
  Grid
} from '@material-ui/core';
import { FormViewContent } from 'components/FormViewContent';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import atoms from 'ctsutheme/components/atoms';
import { BoolToString, GetEmptyValue } from 'components';

const { Divider } = atoms;

const styles = theme => ({
  root: {}
});

const OpenConfig = ({ openConfig }) => (
  <Grid container spacing={4}>
    <Grid item xs>
      <FormViewContent
        primaryText="OPEN Protocol?"
        secondaryText={(
          <>
            {<BoolToString boolValue={openConfig && openConfig.isEnrollThruOpen} />}
            {openConfig && openConfig.openActivationDate && (
              <>
                &nbsp;|&nbsp;Activated:&nbsp;
                <GetEmptyValue value={openConfig.openActivationDate} />
              </>
            )}
          </>
)}
      />
      <Divider />
      <FormViewContent
        primaryText="OPEN to Load to Rave?"
        secondaryText={<BoolToString boolValue={openConfig && openConfig.isOpenLdRave} />}
      />
      <Divider />
      <FormViewContent
        primaryText="OPEN Slot Reservation?"
        secondaryText={<BoolToString boolValue={openConfig && openConfig.isSlotReservation} />}
      />
      <Divider />
      <FormViewContent
        primaryText="Cohort-Arm Management"
        secondaryText={<BoolToString boolValue={openConfig && openConfig?.isCohortArmManagement} />}
      />
      <Divider />
      <FormViewContent
        primaryText="Load to CTEP-AERS"
        secondaryText={<BoolToString boolValue={openConfig && openConfig.isOpenLdCaaers} />}
      />
      <Divider />
      <FormViewContent
        primaryText="Non-Patient"
        secondaryText={<BoolToString boolValue={openConfig && openConfig.isCcdr} />}
      />
      <Divider />
      
    </Grid>
  </Grid>
);

const ViewOpenSetupConfig = withStyles(styles)(compose()(OpenConfig));

export default ViewOpenSetupConfig;
